import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import OrderTrackerScreen from './modules/order-tracking/screens/order-tracker.screen';
import AuthScreen from './modules/auth/screens/auth.screen';
import UsersScreen from './modules/users/screens/users.screen';
import { DeliveriesScreen } from './modules/deliveries/screens';
import { OrdersScreen } from './modules/orders/screens';
import { PrimeReactProvider } from 'primereact/api';
import { validateAuth } from './modules/auth/service';
import { ProtectedRoute, Loading } from './modules/common';
import "primereact/resources/themes/viva-light/theme.css";
import './App.css';
import { UserRoles } from './modules/common/utils/util';

// Componente para redireccionar a usuarios ya autenticados
const AuthRedirect = ({ children }: { children: React.ReactElement }) => {
  const [isAuthenticated, setIsAuthenticated] = React.useState<boolean | null>(null);
  
  useEffect(() => {
    const checkAuth = async () => {
      const isValid = await validateAuth();
      setIsAuthenticated(isValid);
    };
    checkAuth();
  }, []);
  
  if (isAuthenticated === null) {
    // Mientras verifica, muestra una pantalla de carga
    return <Loading text="Verificando autenticación..." />;
  }
  
  return isAuthenticated ? <Navigate to="/deliveries" replace /> : children;
};

function App() {
  useEffect(() => {
    const tryRefresh = async () => {
      await validateAuth();
    };
    
    let interval: any;
    interval = setInterval(tryRefresh, 10 * 60 * 1000); // 10 minutos
    tryRefresh();
    
    return function cleanup () {
      clearInterval(interval);
    }
    
  }, []);

  return (
    <PrimeReactProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/orders" element={<OrderTrackerScreen />} />
          <Route path="/users" element={
            <ProtectedRoute allowedRoles={[UserRoles.ADMIN]}>
              <UsersScreen />
            </ProtectedRoute>
          } />
          <Route path="/order" element={
            <ProtectedRoute allowedRoles={[UserRoles.ADMIN, UserRoles.VIEWER, UserRoles.EDITOR]}>
              <OrdersScreen />
            </ProtectedRoute>
          } />
          <Route path="/deliveries" element={
            <ProtectedRoute allowedRoles={[UserRoles.ADMIN, UserRoles.VIEWER, UserRoles.EDITOR]}>
              <DeliveriesScreen />
            </ProtectedRoute>
          } />
          <Route path="/auth/login" element={
            <AuthRedirect>
              <AuthScreen />
            </AuthRedirect>
          } />
          <Route path="/auth" element={<Navigate to="/auth/login" replace />} />
          <Route path="/" element={<Navigate to="/auth/login" replace />} />
        </Routes>
      </BrowserRouter>
    </PrimeReactProvider>
  );
}

export default App;
